export default __webpack_public_path__ + "static/media/Drum_img_03.da3f9d51.png";